export class FormElementListingField {
  // #region Properties

  public Id: number;
  public LabelText: string;
  public HelpText: string;
  public Visible: boolean;

  // #endregion

  public constructor() {
    this.Id = 0;
    this.LabelText = '';
    this.HelpText = '';
    this.Visible = false;
  }
}
